import React, { useEffect } from "react";
import "./index.css";
import { useWebServer } from "../../providers";
import * as XLSX from "xlsx";
import { CollectionsFormData } from "../../types";
import dayjs from "dayjs";
import { getCollectionsSummary } from "../../stores/reports/action";
import { useAppDispatch, useAppSelector } from "../../stores/store";
import BatchDataFilter from "../../components/BatchDataFilter";
import CollectionsSummaryTable from "../../components/Reports/CollectionsSummary";
import { fetchCollectionSites } from "../../stores/collectionSites/actions";
import { fetchTrapTypes } from "../../stores/collectionSites/actions";
import { fetchDevices } from "../../stores/devices/actions";

const ReportView = () => {
  const dispatch = useAppDispatch();
  const { sendRequest } = useWebServer();
  const loading = useAppSelector((state) => state.reports.loading);
  const data = useAppSelector((state) => state.reports.data);

  // fetch initial data
  useEffect(() => {
    dispatch(fetchCollectionSites(sendRequest));
    dispatch(fetchTrapTypes(sendRequest));
    dispatch(fetchDevices(sendRequest));
  }, [dispatch, sendRequest]);

  const handleSubmit = (formData: CollectionsFormData) => {
    dispatch(
      getCollectionsSummary({
        sendRequest,
        form: formData,
      })
    );
  };

  const tableRef = React.useRef<HTMLDivElement>(null);

  const exportToExcel = () => {
    const table = tableRef.current;
    if (table) {
      // Get header rows and use the SECOND header row if present (skip the first)
      const headerRows = table.querySelectorAll("thead tr");
      const headerRow = headerRows.length > 1 ? headerRows[1] : headerRows[0];
      // Collect header cells from the chosen header row (support th/td just in case)
      const headerData = headerRow
        ? Array.from(headerRow.querySelectorAll("th, td")).map(
            (cell) => cell.textContent
          )
        : [];
      console.log("headerData", headerData);
      const data = Array.from(table.querySelectorAll("tbody tr")).map((row) => {
        return Array.from(row.querySelectorAll("th, td")).map(
          (cell) => cell.textContent
        );
      });

      const excelData: string[][] = [headerData, ...data].map((row) =>
        row.map((cell) => (cell ?? "").toString().trim())
      );
      const worksheet = XLSX.utils.aoa_to_sheet(excelData);
      const colCount = excelData.reduce((max, r) => Math.max(max, r.length), 0);
      const colWidths = Array.from({ length: colCount }).map((_, i) => {
        const maxLen = excelData.reduce((m, r) => {
          const val = r[i] ?? "";
          return Math.max(m, val.length);
        }, 0);
        const wch = Math.min(Math.max(maxLen + 2, 10), 60);
        return { wch } as XLSX.ColInfo;
      });
      worksheet["!cols"] = colWidths;

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(
        workbook,
        `collections_report_${dayjs().format("YYYY-MM-DDTHH:mm")}.xlsx`
      );
    }
  };

  const handleDownload = () => {
    exportToExcel();
  };

  return (
    <div className="">
      <BatchDataFilter
        handleSubmit={handleSubmit}
        handleDownload={handleDownload}
      />
      <div ref={tableRef}>
        <CollectionsSummaryTable data={data} isLoading={loading} />
      </div>
    </div>
  );
};

export default ReportView;
